module.exports = __webpack_public_path__ + "static/img/wx_jkzs_jcjg.png";